import { render } from "./TextAccordion.vue?vue&type=template&id=7b58c73c"
import script from "./TextAccordion.vue?vue&type=script&lang=ts"
export * from "./TextAccordion.vue?vue&type=script&lang=ts"

import "./TextAccordion.vue?vue&type=style&index=0&id=7b58c73c&lang=scss"
script.render = render

export default script